<template>
  <CSidebar
    dropdownMode="openActive"
    colorScheme="light"
    :show="show"
    @update:show="toggleShowHide"
  >
    <CSidebarBrand class="d-md-down-none bg-white c-header">
      <img v-bind:src="logo" alt="logo" class="menu_logo" />
    </CSidebarBrand>

    <div class="c-sidebar-nav-item px-2">
      <span class="clientes filters__search">
        <input
            type="text"
            v-model="filter"
            placeholder="Pesquisar menu"
        />
        <fa-icon icon="search" />
      </span>
    </div>

    <CSidebarNav sync>
      <CSidebarNavItem name="Home" to="/" />

      <CSidebarNavDropdown
        v-for="menu in menus"
        :key="menu.menu"
        :name="menu.menu"
        :route="menu.href"
        :show="filter !== '' ? true : null"
      >
        <template v-for="itemMenu in menu.children">
          <li
            v-if="itemMenu.requerLicenca"
            :key="itemMenu.href"
            class="c-sidebar-nav-item"
          >
            <router-link :to="itemMenu.href" class="c-sidebar-nav-link">
              <CIcon :name="itemMenu.icon" class="c-sidebar-nav-icon" />
              {{ itemMenu.menu }}
              <span
                class="badge-requer-licenca"
                title="Requer licença para utilização - Entre em contato com o time comercial"
              >
                <fa-icon icon="star" />
              </span>
            </router-link>
          </li>
          <CSidebarNavItem
            v-else
            :key="itemMenu.href"
            :name="itemMenu.menu"
            :to="itemMenu.href"
            :icon="itemMenu.icon"
          />
        </template>
      </CSidebarNavDropdown>
    </CSidebarNav>

    <div class="sidebar-collapse-toggle" @click="toggleShowHide(!show)">
      <fa-icon :icon="show ? 'angle-double-left' : 'angle-double-right'" />
      <span v-if="show" class="sidebar-collapse-text">Recolher</span>
    </div>
  </CSidebar>
</template>
<script>
import config from "../../config";
import sidebarMenus from "../../config/sideBar";
import _map from "lodash/map";
import _find from "lodash/find";
import clone from "just-clone";
import {stringContainsObject} from "@/helpers/utils";

export default {
  name: "TheSidebar",
  props: ["show", "toggleShowHide", "modulos", "licencasSistemas", "licencasModulos"],
  computed: {
    menus() {
      const menus = [];

      _map(this.availableMenus, (availableMenu) => {
        let subMenu = [];

        _map(availableMenu.children, (itemMenu) => {
          let modulo = _find(this.modulos, { nome: itemMenu.modulo });
          let filtrado = stringContainsObject(
              this.filter,
              ['menu', 'modulo', 'href', 'descPlural', 'descSingular', 'nome'],
              {
                ...itemMenu,
                ...modulo
              }
          );

          if (modulo && modulo.autorizado && filtrado) {
            let item = clone(itemMenu);

            // O rótulo vem do módulo (descPlural), que é editável pelo cliente.
            // A exceção é o item que declara `menu` no sideBar: um mesmo módulo
            // pode aparecer em mais de uma entrada apontando para telas
            // diferentes — Integrações configuradas e Marketplace, por exemplo —
            // e aí o nome do módulo não distingue uma da outra.
            item.menu = itemMenu.menu || modulo.descPlural;

            if (item.sistemas && item.sistemas.length > 0 && this.licencasSistemas) {
              const possuiLicenca = item.sistemas.some(s => this.licencasSistemas[s]);
              if (!possuiLicenca) {
                item.requerLicenca = true;
              }
            }

            if (item.moduloLicenca && this.licencasModulos && !this.licencasModulos._ilimitado) {
              if (!this.licencasModulos[item.moduloLicenca]) {
                item.requerLicenca = true;
              }
            }

            subMenu.push(item);
          }
        });

        if (subMenu.length > 0) {
          let menu = clone(availableMenu);
          menu.children = subMenu;
          menus.push(menu);
        }
      });

      return menus;
    },
  },
  data() {
    return {
      filter: "",
      currentUrl: "",
      logo: config.api + "/images/logo/s/ADMIN",
      availableMenus: sidebarMenus,
    };
  },
  beforeMount() {
    this.currentUrl = this.$route.name;
  },
  watch: {
    $route(to, from) {
      this.currentUrl = to.name;
    },
  },
};
</script>
<style scoped>
.badge-requer-licenca {
  margin-left: auto;
  color: #f0ad4e;
  font-size: 11px;
  display: flex;
  align-items: center;
}
.sidebar-collapse-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  margin: 8px 12px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  color: #6b7280;
  font-size: 0.78rem;
  cursor: pointer;
  transition: all 0.15s;
}
.sidebar-collapse-toggle:hover {
  background: #f0f4ff;
  border-color: #818cf8;
  color: #6366f1;
}
.sidebar-collapse-text {
  font-weight: 500;
}
</style>
